export const normalizeSearchStatus = (status) => {
    const normalizedStatus = String(status || "")
        .trim()
        .toLowerCase();

    if (
        normalizedStatus === "processing" ||
        normalizedStatus === "external_search_in_progress" ||
        normalizedStatus === "superseded"
    ) {
        return "processing";
    }

    if (
        normalizedStatus === "done" ||
        normalizedStatus === "completed" ||
        normalizedStatus === "success"
    ) {
        return "completed";
    }

    if (
        normalizedStatus === "failed" ||
        normalizedStatus === "error" ||
        normalizedStatus === "system_error" ||
        normalizedStatus === "cancelled"
    ) {
        return "failed";
    }

    if (normalizedStatus === "no_results") {
        return "no_results";
    }

    return "unknown";
};

export const isSearchProcessing = (status) =>
    normalizeSearchStatus(status) === "processing";

export const isSearchCompleted = (status) =>
    normalizeSearchStatus(status) === "completed";

export const isSearchFailed = (status) =>
    normalizeSearchStatus(status) === "failed";

export const isSearchNoResults = (status) =>
    normalizeSearchStatus(status) === "no_results";

export const getSearchStatusBadge = (status) => {
    const normalizedStatus = normalizeSearchStatus(status);

    if (normalizedStatus === "processing") {
        return {
            label: "Processing",
            status: normalizedStatus,
            className: "bg-amber-50 text-amber-700 ring-1 ring-amber-200",
        };
    }

    if (normalizedStatus === "completed") {
        return {
            label: "Completed",
            status: normalizedStatus,
            className:
                "bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200",
        };
    }

    if (normalizedStatus === "failed") {
        return {
            label: "Failed",
            status: normalizedStatus,
            className: "bg-red-50 text-red-700 ring-1 ring-red-200",
        };
    }

    if (normalizedStatus === "no_results") {
        return {
            label: "No Results",
            status: normalizedStatus,
            className: "bg-slate-100 text-slate-700 ring-1 ring-slate-200",
        };
    }

    return {
        label: "",
        status: "unknown",
        className: "",
    };
};

export const canCreateCampaignFromSearch = (status) =>
    isSearchCompleted(status);

export const canViewCampaignFromSearch = (status) =>
    isSearchCompleted(status);
